var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.5;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,192c17.7,0,32-14.3,32-32s-14.3-32-32-32s-32,14.3-32,32S238.3,192,256,192z M296,336h-16v-88c0-13.2-10.7-24-24-24 h-32c-13.2,0-24,10.8-24,24c0,13.2,10.8,24,24,24h8v64h-16c-13.2,0-24,10.8-24,24s10.8,24,24,24h80c13.2,0,24-10.8,24-24 S309.3,336,296,336z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M256,128 c17.7,0,32,14.3,32,32s-14.3,32-32,32s-32-14.3-32-32S238.3,128,256,128z M296,384h-80c-13.2,0-24-10.7-24-24s10.8-24,24-24h16v-64 h-8c-13.2,0-24-10.8-24-24s10.8-24,24-24h32c13.2,0,24,10.8,24,24v88h16c13.2,0,24,10.8,24,24S309.3,384,296,384z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfo);
export default __webpack_public_path__ + "static/media/circle-info.1ade85f15e1baf87f98a982849eba252.svg";
export { ForwardRef as ReactComponent };